import { PropTypes } from 'prop-types'
import React from 'react'
import { Typography, Paper, Avatar, Button } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { VerifiedUserOutlined } from '@material-ui/icons'
import GoogleIco from './imgs/GoogleIco'
import FacebookIcon from './imgs/FacebookIcon'
import TwitterIcon from '@material-ui/icons/Twitter';

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
    },
    submit: {
        marginTop: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1),
    }
})

function Logins(props) {
    const { classes } = props

    return (
        <main className={classes.main}>
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <VerifiedUserOutlined />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Hi Cart User
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    fullWidth
                    edge="start"
                    className={classes.submit}
                    startIcon={<GoogleIco />}
                    onClick={() => window.open('/auth/google', '_self')}
                >
                    Login with Google
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    disabled
                    className={classes.submit}
                    startIcon={<FacebookIcon />}
                    onClick={() => window.open('/auth/facebook', '_self')}
                >
                    Login with Facebook
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    style={{ backgroundColor: '#fff', color: 'blue' }}
                    className={classes.submit}
                    startIcon={<TwitterIcon />}
                    disabled
                    onClick={() => window.open('/auth/twitter', '_self')}
                >
                    Login with twitter
                </Button>

            </Paper>
        </main>
    )
}

Logins.propTypes = {
    classes: PropTypes.object,
}


export default withStyles(styles)(Logins)